import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Clock, Menu, X } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Projects & Vendors',
    path: '/projects-vendors'
  }, {
    name: 'Contact Us',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md" data-id="element-60">
      {/* Top Bar - hides on scroll */}
      <div className={`bg-[#1e3a5f] text-white overflow-hidden transition-all duration-300 hidden md:block ${isScrolled ? 'max-h-0 py-0' : 'max-h-20 py-2'}`} data-id="element-61">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center text-sm" data-id="element-62">
          <div className="flex items-center space-x-6" data-id="element-63">
            <div className="flex items-center" data-id="element-64">
              <Phone className="w-4 h-4 mr-2 text-[#d4a017]" data-id="element-65" />
              <a href="tel:8653130028" className="hover:text-[#d4a017] transition-colors" data-id="element-66">
                865-313-0028
              </a>
            </div>
            <div className="flex items-center" data-id="element-67">
              <Mail className="w-4 h-4 mr-2 text-[#d4a017]" data-id="element-68" />
              <a href="mailto:info@mmpipeservices.com" className="hover:text-[#d4a017] transition-colors" data-id="element-69">
                info@mmpipeservices.com
              </a>
            </div>
          </div>
          <div className="flex items-center font-bold text-[#d4a017]" data-id="element-70">
            <Clock className="w-4 h-4 mr-2" data-id="element-71" />
            <span data-id="element-72">24/7 EMERGENCY SERVICE AVAILABLE</span>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`} data-id="element-73">
        <div className="flex justify-between items-center" data-id="element-74">
          {/* Logo - shrinks on scroll */}
          <div className="flex-shrink-0 flex items-center" data-id="element-75">
            <Link to="/" className="flex items-center" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/7UkpvhWwAjtzJHkmXMwSvP/MANDM-PIPE-SERVICES-LOGO.png" alt="M&M Pipe Services LLC" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-12 md:h-14' : 'h-16 md:h-20'}`} data-id="element-77" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-78">
            <nav className="flex space-x-6 items-center" data-id="element-79">
              {navItems.map(item => <Link key={item.name} to={item.path} className={`text-sm font-bold uppercase tracking-wide transition-colors ${isActive(item.path) ? 'text-[#1e3a5f] border-b-2 border-[#d4a017]' : 'text-gray-700 hover:text-[#1e3a5f] hover:border-b-2 hover:border-[#d4a017] border-b-2 border-transparent'}`} data-id="element-80">
                  {item.name}
                </Link>)}
            </nav>
            <a href="tel:8653130028" className={`bg-[#d4a017] hover:bg-[#b88b14] text-[#1e3a5f] rounded font-bold transition-all uppercase text-sm tracking-wide shadow-md ${isScrolled ? 'px-4 py-2' : 'px-6 py-3'}`} data-id="element-81">
              Call For Service
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center" data-id="element-82">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-[#1e3a5f] hover:text-[#d4a017] focus:outline-none" data-id="element-83">
              {mobileMenuOpen ? <X className="w-8 h-8" data-id="element-84" /> : <Menu className="w-8 h-8" data-id="element-85" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 py-4 px-4 shadow-lg absolute w-full top-full left-0" data-id="element-86">
          <div className="flex flex-col space-y-4" data-id="element-87">
            {navItems.map(item => <Link key={item.name} to={item.path} onClick={() => setMobileMenuOpen(false)} className={`block text-lg font-bold uppercase tracking-wide ${isActive(item.path) ? 'text-[#1e3a5f]' : 'text-gray-800'}`} data-id="element-88">
                {item.name}
              </Link>)}
            <div className="pt-4 border-t border-gray-100 space-y-4" data-id="element-89">
              <a href="tel:8653130028" className="flex items-center text-[#1e3a5f] font-semibold" data-id="element-90">
                <Phone className="w-5 h-5 mr-3 text-[#d4a017]" data-id="element-91" /> 865-313-0028
              </a>
              <a href="mailto:info@mmpipeservices.com" className="flex items-center text-[#1e3a5f] font-semibold" data-id="element-92">
                <Mail className="w-5 h-5 mr-3 text-[#d4a017]" data-id="element-93" />{' '}
                info@mmpipeservices.com
              </a>
              <a href="tel:8653130028" className="block w-full text-center bg-[#d4a017] text-[#1e3a5f] px-4 py-3 rounded font-bold uppercase" data-id="element-94">
                Call For Service
              </a>
            </div>
          </div>
        </div>}
    </header>;
};